import { createContext, useContext } from "react";

/**
 * Báo cho trang chi tiết / form biết nó đang nằm dưới thanh tab của một module (VD Kho: Phiếu nhập xuất | Báo cáo NXT | …).
 * Khi đó thanh tiêu đề chứng từ không đưa lên thanh trên cùng mà đặt ngay dưới thanh tab:
 * thứ tự chuẩn là thanh trên cùng (tên module) → tab module → tiêu đề chứng từ → nội dung.
 * `setDocShell` cho module biết đang mở trang chứng từ để bỏ lề, tiêu đề nằm sát dưới tab.
 */
export interface ModuleTabsContextValue {
    setDocShell: (active: boolean) => void;
}

export const ModuleTabsContext = createContext<ModuleTabsContextValue | null>(null);

export const useModuleTabs = () => useContext(ModuleTabsContext);
